// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__29sTc","inner":"Form_inner__2MvcM","range":"Form_range__3JRG_","name":"Form_name__XLi5t","actions":"Form_actions__3Hscw"};